module.exports = __webpack_public_path__ + "static/media/searchTerm2.853f4028.png";